module.exports = __webpack_public_path__ + "static/media/creative-team-bro-business.33bdca00.svg";